import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getSymbolsApi } from '@flipster/apis/v2/market';
import { InstrumentProductTypeEnum } from '@flipster/apis/v2/snapshot';

export function useSymbols(productType?: 'perpetual' | 'spot') {
  const fullProductType = useMemo(() => {
    if (!productType) return undefined;
    if (productType === 'perpetual') return InstrumentProductTypeEnum.Pswap;
    if (productType === 'spot') return InstrumentProductTypeEnum.Spot;
  }, [productType]);

  const {
    isPending,
    data: symbols,
    refetch: refetchSymbols,
  } = useQuery({
    queryKey: ['getSymbolsApi', fullProductType],
    queryFn: () =>
      getSymbolsApi(
        fullProductType && {
          productType: fullProductType,
        },
      ).then((res) => res.data),
  });

  const totalSymbol = symbols?.data.marketCap.length || 0;

  return { isLoading: isPending, symbols, refetchSymbols, totalSymbol };
}
